/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetTransactionHistoryByIdQuery } from '../models/GetTransactionHistoryByIdQuery';
import type { GetTransactionHistoryByIdResult } from '../models/GetTransactionHistoryByIdResult';
import type { ListBusinessExternalIdsQuery } from '../models/ListBusinessExternalIdsQuery';
import type { ListBusinessExternalIdsResult } from '../models/ListBusinessExternalIdsResult';
import type { ListTransactionHistoryQuery } from '../models/ListTransactionHistoryQuery';
import type { ListTransactionHistoryResult } from '../models/ListTransactionHistoryResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VisaAdminService {
    /**
     * List all businesses with their external IDs
     * @param requestBody
     * @returns ListBusinessExternalIdsResult Success
     * @throws ApiError
     */
    public static postApiVisaAdminListBusinessExternalIds(
        requestBody?: ListBusinessExternalIdsQuery,
    ): CancelablePromise<ListBusinessExternalIdsResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/visa-admin/list-business-external-ids',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List Visa transaction history
     * @param requestBody
     * @returns ListTransactionHistoryResult Success
     * @throws ApiError
     */
    public static postApiVisaAdminListTransactionHistory(
        requestBody?: ListTransactionHistoryQuery,
    ): CancelablePromise<ListTransactionHistoryResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/visa-admin/list-transaction-history',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get Visa transaction history by unique transaction ID
     * @param requestBody
     * @returns GetTransactionHistoryByIdResult Success
     * @throws ApiError
     */
    public static postApiVisaAdminGetTransactionHistoryById(
        requestBody?: GetTransactionHistoryByIdQuery,
    ): CancelablePromise<GetTransactionHistoryByIdResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/visa-admin/get-transaction-history-by-id',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
}
